import LiquidEther from "../../../../components/LiquidEther";
import "./Banner.scss"

function Banner() {


    return (

        <section id="home" className="banner">
            <div style={{ width: '100%', height: '100vh', position: 'relative' }} className="no-interaction">
                <LiquidEther
                    colors={['#5227FF', '#FF9FFC', '#B19EEF']}
                    mouseForce={20}
                    cursorSize={100}
                    isViscous
                    viscous={30}
                    iterationsViscous={32}
                    iterationsPoisson={32}
                    resolution={0.5}
                    isBounce={false}
                    autoDemo={true}
                    autoSpeed={0.5}
                    autoIntensity={2.2}
                    takeoverDuration={0.25}
                    autoResumeDelay={800}
                    autoRampDuration={0.6}
                />
            </div>
            <div className="content">
                <div className="titleWrapper">
                    <h1 className="title">
                        Mayank Sharma
                    </h1>
                    <p className="subtitle">UI/UX Designer</p>
                </div>
            </div>
            {/* <div className="background"></div> */}
            {/* <div className="content">

                <div className="headerWrapper">
                    <div className="avatar">
                        <div className="avatarPlaceholder">👤</div>
                    </div>
                    <div className="titleWrapper">
                        <h1 className="title">
                            Mayank <span className="year">Sharma</span>
                        </h1>
                        <p className="subtitle">UI/UX Designer</p>
                    </div>
                </div>
                <div className="menuButtons">
                    <button className="menuButton">START</button>
                    <button className="menuButton">OPTIONS</button>
                    <button className="menuButton">EXIT</button>
                </div>
            </div> */}
            <p className="quote">Focused on building interfaces that are clear, intuitive, and visually refined.</p>

            <div className="banner-footer">
                <span className="left">PORTFOLIO</span>
                <span className="right">2026</span>
            </div>
        </section>
    )
}

export default Banner;